import { configureStore } from '@reduxjs/toolkit';

import websiteSlice from './website';

/**
 * 应用程序状态
 */
const store = configureStore({
    reducer: {
        website: websiteSlice.reducer,
    },
});

/**
 * 输出状态对象
 */
export default store;
